import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {className} = self.get();

    return h('a', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this),
        'ev-click': function() {try {return (self.to )} catch(e) {_e(e)}}.call($this)
    }, function() {try {return (self.get('children') )} catch(e) {_e(e)}}.call($this), _className(function() {try {return (className )} catch(e) {_e(e)}}.call($this)))
}